"use strict";

var PropTypes = require("prop-types");

var ProjectActions = require("./ProjectActions");
var ProjectStore = require("./ProjectStore");

var GiftArray = require("./GiftArray");

class ProjectGiftArray extends React.Component {
	render() {
		return (
			<GiftArray
				{...this.props}
				thisArg={this}
				tangibleActions={ProjectActions}
				tangibleStore={ProjectStore}
				tangibleType="project"
				displayCodeProperty="ProjectCode"
				reactComponentCategory="ProjectComponents"
			/>
		);
	}
}

ProjectGiftArray.defaultProps = {
	includeCurrencySymbol: true,
	includeOther: false,
	otherText: "Other",
	showDecimals: true
};

ProjectGiftArray.propTypes = {
	buttonStyle: PropTypes.object,
	childClass: PropTypes.string,
	context: PropTypes.string,
	dataComponentId: PropTypes.string,
	dataNestedId: PropTypes.string,
	dataRepeatedId: PropTypes.string,
	giftAmounts: PropTypes.array,
	hideWhenSubaccounts: PropTypes.bool,
	includeCurrencySymbol: PropTypes.bool,
	includeOther: PropTypes.bool,
	isCustomTheme: PropTypes.bool,
	isDesignMode: PropTypes.bool,
	minimumAmount: PropTypes.number,
	otherText: PropTypes.string,
	project: PropTypes.object,
	showDecimals: PropTypes.bool,
	theme: PropTypes.string,
	type: PropTypes.oneOf(["button", "radio", "dropdown"]).isRequired
};

module.exports = ProjectGiftArray;
